export default {
  install: function(Vue, options) {
    const component = {
      name: 'ProgressDialog',
      props: {
        visible: {
          type: Boolean,
          default: true
        },
        width: {
          type: Number,
          default: 300
        },
        backgroundColor: {
          type: String,
          default: 'secondary'
        },
        foregroundColor: {
          type: String,
          default: 'white'
        },
        dark: {
          type: Boolean,
          default: true
        }
      },
      template: `
<v-container>
  <v-dialog v-model="visible" hide-overlay persistent :width="width">
    <v-card :color="backgroundColor" :dark="dark">
      <v-card-text>
        <slot></slot>
        <v-progress-linear indeterminate :color="foregroundColor" class="mb-0"></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</v-container>
      `
    };
    Vue.component('progress-dialog', component);
  }
};



// WEBPACK FOOTER //
// ./src/components/utils/ProgressDialog.js